import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { th } from 'style/theme';

const Bg = styled.div`
  padding: 4px;
  margin-bottom: 16px;
  border-radius: 4px;
  font-weight: bold;
  font-size: 13px;
  background-color: #e3ffff;
  color: ${th('colors.black')};
`;

const RestrictionWarning = ({ field }) => {
  return <Bg>{`This ${field} has restrictions to buy insurance.`}</Bg>;
};

RestrictionWarning.propTypes = {
  field: PropTypes.string.isRequired
};

export default RestrictionWarning;
